import React from 'react';
import { Canvas } from '@react-three/fiber';
import Rack3DView from './Rack3DView';

function Viewer({ selectedModules }) {
    return (
        <div className="viewer" >
           {/*}  <Rack2DView selectedModules={selectedModules} /> {/* 2D View */}
            <Canvas shadows>
                <Rack3DView selectedModules={selectedModules} /> {/* 3D View */}
            </Canvas>
        </div>
    );
}

export default Viewer;
